module.exports = __webpack_public_path__ + "img/Delete2.f706b546.svg";